import type { StorySection } from './types';
import { StoreImage } from '../../ui/StoreImage';

/**
 * Kaffet och Om oss. Mobil: stor bild med texten i en färgad panel som ligger över bildens nederkant.
 * Dator: bild och text sida vid sida, och sidan byts mellan sektionerna.
 */
export function StorySections({ sections }: { sections: StorySection[] }) {
  if (sections.length === 0) return null;
  return (
    <div className="cn-stories">
      {sections.map((s, i) => (
        <article key={s.id} className={`cn-story cn-story--${s.tone}${i % 2 === 1 ? ' cn-story--flip' : ''}${s.imageUrl ? '' : ' cn-story--noimg'}`}>
          {s.imageUrl && (
            <div className="cn-story__media">
              <StoreImage src={s.imageUrl} width={1080} alt={s.imageAlt ?? ''} loading="lazy" decoding="async" />
            </div>
          )}
          <div className="cn-story__panel">
            {s.chips && s.chips.length > 0 && (
              <ul className="cn-story__chips">
                {s.chips.map((c) => (
                  <li key={c}>{c}</li>
                ))}
              </ul>
            )}
            <h2 className="cn-story__title">{s.title}</h2>
            <p className="cn-story__text">{s.text}</p>
          </div>
        </article>
      ))}
    </div>
  );
}
